export const job_field = [
    { value: 1, label: "农、林、牧、渔业" },
    { value: 2, label: "采矿业" },
    { value: 3, label: "制造业" },
    { value: 4, label: "能源行业" },
    { value: 5, label: "建筑业" },
    { value: 6, label: "批发零售业" },
    { value: 7, label: "交通运输业" },
    { value: 8, label: "住宿餐饮业" },
    { value: 9, label: "金融业" },
    { value: 11, label: "房地产业" },
    { value: 12, label: "专业服务业" },
    { value: 13, label: "租赁商务服务业" },
    { value: 14, label: "公共管理与社会保障" },
    { value: 15, label: "教育" },
    { value: 16, label: "卫生和社会工作" },
    { value: 17, label: "艺术娱乐休闲业" },
    { value: 18, label: "其他服务业" },
    { value: 19, label: "互联网电商" },
    { value: 20, label: "计算机科学和技术" },
    { value: 21, label: "电信业" },
    { value: 22, label: "媒体出版" },
    { value: 23, label: "医药生物技术" },
    { value: 24, label: "法律服务" },
    { value: 25, label: "管理咨询" },
    { value: 26, label: "设计和创意服务" },
    { value: 27, label: "研发和实验开发" },
    { value: 28, label: "其它" },
  ];

  export const academic_field = [
    { value: 1, label: "本科" },
    { value: 2, label: "硕士" },
    { value: 3, label: "博士" },
    { value: 4, label: "博士后工作" },
    { value: 5, label: "其他" },
  ];